export const API = "https://backend-xdmlj.run.goorm.site";
